import React from "react";
import { Link } from "react-router-dom";
import { ScanFace } from "lucide-react";
import { BRAND } from "../lib/brand";
import { COMPETITORS } from "../data/competitors";
import EmailCapture from "./EmailCapture";

const cols = [
  {
    title: "Product",
    links: [
      { to: "/", label: "Scan your face" },
      { to: "/features", label: "Features" },
      { to: "/pricing", label: "Pricing" },
      { to: "/leaderboard", label: "Leaderboard" },
      { to: "/dashboard", label: "Dashboard" },
    ],
  },
  {
    title: "Compare",
    links: [
      { to: "/vs", label: "All comparisons" },
      { to: "/best-ai-face-analysis-tool", label: "Best face analysis tools" },
      { to: "/vs/facekit", label: "FaceKit alternative" },
      { to: "/vs/umax", label: "Umax alternative" },
      { to: "/vs/looksmax-ai", label: "LooksMax AI alternative" },
    ],
  },
  {
    title: "Learn",
    links: [
      { to: "/blog", label: "Blog" },
      { to: "/blog/looksmaxxing-complete-guide", label: "Looksmaxxing guide" },
      { to: "/blog/best-ai-face-analysis-tools", label: "Best AI face tools" },
      { to: "/blog/how-attractive-am-i-test", label: "How attractive am I?" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/privacy", label: "Privacy" },
      { to: "/terms", label: "Terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="container py-16">
        <div className="mb-14 grid items-center gap-6 rounded-2xl border border-border bg-secondary/20 p-8 lg:grid-cols-2">
          <div>
            <h3 className="font-display text-2xl">Join the glow-up list</h3>
            <p className="mt-1 text-sm text-muted-foreground">A weekly tip + your progress nudge. No spam, unsubscribe anytime.</p>
          </div>
          <EmailCapture source="footer" compact />
        </div>
        <div className="grid gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <ScanFace className="h-6 w-6 text-primary" />
              <span className="font-display text-xl font-semibold">{BRAND.name}</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">{BRAND.tagline}</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="label-eyebrow mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link to={l.to} className="text-sm text-muted-foreground transition hover:text-foreground">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap gap-x-4 gap-y-1 border-t border-border pt-6">
          {COMPETITORS.map((c) => (
            <Link key={c.slug} to={`/vs/${c.slug}`} className="text-xs text-muted-foreground/70 transition hover:text-foreground">
              {c.name} alternative
            </Link>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} {BRAND.name}. For self-improvement and entertainment. Not a medical device.</p>
          <p className="font-display text-2xl text-muted-foreground/30">{BRAND.name}</p>
        </div>
      </div>
    </footer>
  );
}
